import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';

import type { SpartacuxProductDiscoveryDomainState } from '../productDiscovery.model';
import {
  SET_FINGERPRINT,
  SET_FINGERPRINT_FAILED,
  type Action,
} from './fingerprint.actions';
import {
  fingerprintInitialState,
  type FingerprintState,
} from './fingerprint.model';
import { selectFingerprint } from './selectors/selectFingerprint';

export function fingerprintReducer(
  state: FingerprintState = fingerprintInitialState,
  action: Action | HydrateAction<SpartacuxProductDiscoveryDomainState>,
): FingerprintState {
  switch (action.type) {
    case HYDRATE: {
      return {
        ...state,
        fingerprint: selectFingerprint(action.state),
      };
    }
    case SET_FINGERPRINT:
      return {
        ...state,
        fingerprint: action.fingerprint,
      };
    case SET_FINGERPRINT_FAILED:
      return {
        ...state,
        fingerprint: null,
        error: action.error,
      };
    default:
      return state;
  }
}
